/**
 * Converts the given 1D array to a 2D array representing columns where the rows maintain the order of the given array.
 *
 * @example
 *
 * ```typescript
 * columnizeItems(3, [1, 2, 3, 4, 5, 6, 7, 8, 9])
 * // Result: [[1, 4, 7], [2, 5, 8], [3, 6, 9]]
 * ```
 *
 * Note how each inner-array represents 1 column and aligns rows in the given array's order:
 *
 * | First | Second | Third |
 * | ----- | ------ | ----- |
 * | 1     | 2      | 3     |
 * | 4     | 5      | 6     |
 * | 7     | 8      | 9     |
 */
export const columnizeItems = <ArrayType>(numberOfColumns: number, items: ArrayType[]) =>
    items.reduce<ArrayType[][]>(
        (columnsSoFar, currentItem, currentIndex) => {
            columnsSoFar[currentIndex % numberOfColumns].push(currentItem);
            return columnsSoFar;
        },
        [...Array(numberOfColumns)].map(() => []),
    );
